import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MatDialog } from '@angular/material';
import { Ng2DeviceService } from 'ng2-device-detector';
import { ConfigurationService } from '../services/configuration.service';
import { RequisitionService } from '../services/requisition.service';
import { ContractRequisition } from '../models/contractRequisition';
import { Requisition } from '../models/requisition';
import { AgmCoreModule } from '@agm/core';

@Component({
  selector: 'app-form-job',
  templateUrl: './form-job.component.html',
  styleUrls: ['./form-job.component.css']
})
export class FormJobComponent implements OnInit {

  @Input() requisitionEditId: string;
  @Input() disabled: boolean;
  public publicating: boolean;
  public contractRequisition: ContractRequisition;
  public zoom: number;

  public isLinear;
  public firstFormGroup: FormGroup;
  public secondFormGroup: FormGroup;
  public thirdFormGroups: FormGroup[];

  deviceInfo = null;
  chrome_version = '56.0.2924';
  safari_version = '10.0.3';
  explorer_version = '10.0';
  firefox_version = '45.7.0esr';
  browser_version: string;
  errorConnection: boolean;
  noBrowserSupported: string;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private deviceService: Ng2DeviceService,
    private configurationService: ConfigurationService,
    private requisitionService: RequisitionService
  ) { }

  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  ngOnInit() {
    this.zoom = 17;
    this.publicating = false;
    this.isLinear = false;

    this.firstFormGroup = this.fb.group({
      legalname: ['', Validators.required],
      nit: ['', Validators.required],
      legalrep_name: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', Validators.required],
    });

    this.secondFormGroup = this.fb.group({
      contact_name: ['', Validators.required],
      contact_phone: ['', Validators.required],
      contact_email: ['', Validators.required]
    });

    this.thirdFormGroups = [];
    this.contractRequisition = new ContractRequisition();
    if (this.requisitionEditId) {
      this.initContractRequisiton(this.requisitionEditId);
    } else {
      this.initContractRequisiton();
    }

    this.deviceInfo = this.deviceService.getDeviceInfo();
    if (this.deviceInfo.browser === 'chrome') {
      this.browser_version = this.chrome_version;
    } else if (this.deviceInfo.browser === 'safari') {
      this.browser_version = this.safari_version;
    } else if (this.deviceInfo.browser === 'ie') {
      this.browser_version = this.explorer_version;
    } else if (this.deviceInfo.browser === 'firefox') {
      this.browser_version = this.firefox_version;
    } else {
      this.browser_version = '';
    }

    if (this.browser_version !== '') {
      const options = {lexicographical: true, zeroExtend: true};
      const compare = this.versionCompare(this.deviceInfo.browser_version, this.browser_version, options);
      if (compare < 0) {
        this.noBrowserSupported = 'true';
      } else {
        this.noBrowserSupported = 'false';
      }
    } else {
      this.noBrowserSupported = 'true';
    }

    this.configurationService.errorHttp$.subscribe(
      response => {
        if (response) {
          this.errorConnection = true;
        } else {
          this.errorConnection = false;
        }
      }
    );
  }

  initContractRequisiton(requisition?) {
    if (requisition) {
      this.requisitionService.getRequisition(requisition)
      .subscribe(
        res => {
          this.contractRequisition.legalname = res.contract.company.legalname;
          this.contractRequisition.nit = res.contract.company.nit;
          this.contractRequisition.email = res.contract.company.email;
          this.contractRequisition.phone = res.contract.company.phone;

          this.thirdFormGroups.push(this.fb.group({
            contact_name: ['', Validators.required],
            contact_phone: ['', Validators.required],
            contact_email: ['', Validators.required],
            notes: ['', Validators.required],
            position_name: ['', Validators.required],
            vacancies: ['', Validators.required],
            department: ['', Validators.required],
            manager: ['', Validators.required],
            team: ['', Validators.required],
            personal_in_charge: ['', Validators.required],
            salary: ['', Validators.required],
            salary_noshow: ['', Validators.required],
            salary_additional: ['', Validators.required],
            jobtype_id: ['', Validators.required],
            commissions: ['', Validators.required],
            working_days_hours: ['', Validators.required],
            gender: ['', Validators.required],
            gender_desirable: ['', Validators.required],
            age_range: ['', Validators.required],
            experience_years: ['', Validators.required],
            experience_years_desirable: ['', Validators.required],
            functions: ['', Validators.required],
            skills: ['', Validators.required],
            skills_desirable: ['', Validators.required],
            knowledge: ['', Validators.required],
            knowledge_desirable: ['', Validators.required],
            academic_background: ['', Validators.required],
            academic_background_desirable: ['', Validators.required],
            responsibilities: ['', Validators.required],
            languages: ['', Validators.required],
            languages_desirable: ['', Validators.required],
            software: ['', Validators.required],
            software_desirable: ['', Validators.required],
            relevant_aspects: ['', Validators.required],
            relevant_aspects_desirable: ['', Validators.required],
            competences: ['', Validators.required],
            address: ['', Validators.required]
          }));
          this.addRequisition(res);
        },
        () => {
          console.log('Error retrieving Requisition');
        }
      );
    } else {
      this.contractRequisition = {
        id: undefined,
        company_id: undefined,
        contract_id: undefined,
        nit: undefined,
        email: undefined,
        phone: undefined,
        legalname: undefined,
        legalrep_name: undefined,
        contact_email: undefined,
        contact_name: undefined,
        contact_phone: undefined,
        requisitions: []
      };
      this.addRequisition();
    }
  }

  addRequisition(requisition?) {
    if (requisition) {
      this.contractRequisition.requisitions = [];
      this.contractRequisition.requisitions.push({
        id: requisition.id,
        contract_id: requisition.contract_id,
        position_name: requisition.position_name,
        vacancies: requisition.vacancies,
        salary: requisition.salary,
        jobtype_id: requisition.jobtype_id,
        working_days_hours: requisition.working_days_hours,
        address: requisition.address,
        description: requisition.description,
        more_info: requisition.more_info,
        job: requisition.job,
        assigned_freelancers: requisition.assigned_freelancers,
        qa: requisition.qa,
        notes: requisition.notes
      });
    } else {
      this.contractRequisition.requisitions.push({
        id: undefined,
        contract_id: undefined,
        position_name: undefined,
        vacancies: undefined,
        salary: undefined,
        jobtype_id: undefined,
        working_days_hours: undefined,
        address: undefined,
        description: undefined,
        more_info: undefined,
        job: undefined,
        assigned_freelancers: undefined,
        qa: undefined,
        notes: undefined
      });
      this.thirdFormGroups.push(this.fb.group({
        contact_name: ['', Validators.required],
        contact_phone: ['', Validators.required],
        contact_email: ['', Validators.required],
        notes: ['', Validators.required],
        position_name: ['', Validators.required],
        vacancies: ['', Validators.required],
        department: ['', Validators.required],
        manager: ['', Validators.required],
        team: ['', Validators.required],
        personal_in_charge: ['', Validators.required],
        salary: ['', Validators.required],
        salary_noshow: ['', Validators.required],
        salary_additional: ['', Validators.required],
        jobtype_id: ['', Validators.required],
        commissions: ['', Validators.required],
        working_days_hours: ['', Validators.required],
        gender: ['', Validators.required],
        gender_desirable: ['', Validators.required],
        age_range: ['', Validators.required],
        experience_years: ['', Validators.required],
        experience_years_desirable: ['', Validators.required],
        functions: ['', Validators.required],
        skills: ['', Validators.required],
        skills_desirable: ['', Validators.required],
        knowledge: ['', Validators.required],
        knowledge_desirable: ['', Validators.required],
        academic_background: ['', Validators.required],
        academic_background_desirable: ['', Validators.required],
        responsibilities: ['', Validators.required],
        languages: ['', Validators.required],
        languages_desirable: ['', Validators.required],
        software: ['', Validators.required],
        software_desirable: ['', Validators.required],
        relevant_aspects: ['', Validators.required],
        relevant_aspects_desirable: ['', Validators.required],
        competences: ['', Validators.required],
        address: ['', Validators.required]
      }));
    }
    console.log(this.contractRequisition);
  }

  onPostRequisition() {
    this.requisitionService.postRequisition(this.contractRequisition)
    .subscribe(
      data => {
        this.publicating = false;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Requisición Creada', success: true, showIcon: true}});
      },
      error => {
        console.log(error);
        this.dialog.open(MessageBoxDialog, {data: {title: 'No se pudo crear la Requisición',
          message: 'Verifique los datos: ' + error, alert: true, showIcon: true}});
        this.publicating = false;
       }
    );
  }

 /**
 * Compares two software version numbers (e.g. "1.7.1" or "1.2b").
 *
 * This function was born in http://stackoverflow.com/a/6832721.
 *
 * @param {string} v1 The first version to be compared.
 * @param {string} v2 The second version to be compared.
 * @param {object} [options] Optional flags that affect comparison behavior:
 * <ul>
 *     <li>
 *         <tt>lexicographical: true</tt> compares each part of the version strings lexicographically instead of
 *         naturally; this allows suffixes such as "b" or "dev" but will cause "1.10" to be considered smaller than
 *         "1.2".
 *     </li>
 *     <li>
 *         <tt>zeroExtend: true</tt> changes the result if one version string has less parts than the other. In
 *         this case the shorter string will be padded with "zero" parts instead of being considered smaller.
 *     </li>
 * </ul>
 * @returns {number|NaN}
 * <ul>
 *    <li>0 if the versions are equal</li>
 *    <li>a negative integer iff v1 < v2</li>
 *    <li>a positive integer iff v1 > v2</li>
 *    <li>NaN if either version string is in the wrong format</li>
 * </ul>
 *
 * @copyright by Jon Papaioannou (["john", "papaioannou"].join(".") + "@gmail.com")
 * @license This function is in the public domain. Do what you want with it, no strings attached.
 */
versionCompare(v1, v2, options) {
  const lexicographical = options && options.lexicographical,
      zeroExtend = options && options.zeroExtend;
  let v1parts = v1.split('.'),
      v2parts = v2.split('.');

  function isValidPart(x) {
      return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
      return NaN;
  }

  if (zeroExtend) {
      while (v1parts.length < v2parts.length) { v1parts.push('0'); }
      while (v2parts.length < v1parts.length) { v2parts.push('0'); }
  }

  if (!lexicographical) {
      v1parts = v1parts.map(Number);
      v2parts = v2parts.map(Number);
  }

  for (let i = 0; i < v1parts.length; ++i) {
      if (v2parts.length === i) {
        return 1;
      }

      if (Number(v1parts[i]) === Number(v2parts[i])) {
        continue;
      } else if (Number(v1parts[i]) > Number(v2parts[i])) {
        return 1;
      } else {
        return -1;
      }
  }

  if (v1parts.length !== v2parts.length) {
      return -1;
  }

  return 0;
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/form-job/form-job.component.ts